<template>
    <div class="list-group border-radius-2 no-border">
        <FormAdvancedSearch 
            :value="filters" 
            class="list-group-item sticky-top"
            @input="refresh"
            :lockUser="true"
        />
        <ScrollPaginator
            :data="formResponses"
            :submitting="submitting"
            :filters="filters"
            @toPage="toPage"
            :maxPages="5"
            :scrollElementId="scrollElementId"
        >
            <template v-slot:item="{ item: response }">
                <FormListItem 
                    :formResponse="response"
                    @click="toggleFormResponse(response)"
                    :class="{ 'bg-light': value.findIndex(el => el.formresponse_id === response.formresponse_id) > -1}"
                />
            </template>
            <template v-slot:skeletonLoader>
                <SkeletonRow />
            </template>
        </ScrollPaginator>
    </div>
</template>

<script>
import ScrollPaginator from "../../components/Table/ScrollPaginator.vue";
import FormAdvancedSearch from "./AdvancedSearch.vue";
import FormListItem from "./ListItem.vue";
import SkeletonRow from "src/components/Table/SkeletonRow.vue";

export default {
    components: {
        ScrollPaginator,
        FormAdvancedSearch,
        FormListItem,
        SkeletonRow,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        scrollElementId: {
            type: String,
            default: 'main',
        }
    },
    mounted() {
        const promise = this.fetchFormResponses()
        if (promise) promise.then(() => { this.loading = false })
    },
    data() {
        return {
            formResponses: [],
            loading: true,
            submitting: false,
            filters: {
                page: 1,
                page_size: 30,
                total: 0,
                search: '',
                completed: 1,
            },
        }
    },
    methods: {
        fetchFormResponses() {
            if (this.submitting) return
            this.submitting = true

            return this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/list${this.filters.completed == 1 ? 'completed' : 'awaitingresponse'}`, {
                method: 'post',
                data: {
                    ...this.filters,
                    pg: this.filters.page,
                    q: this.filters.search,
                    programme: this.filters.programme ? this.filters.programme.Id : null,
                },
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching competency test formResponses')

                this.formResponses = res.formresponses
                this.filters.page = Number(res.pagination.page)
                this.filters.total = Number(res.pagination.total)
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-treatment-formResponses'),
                })
            }).finally(() => {
                this.submitting = false
            })
        },
        toggleFormResponse(response) {
            const index = this.value.findIndex(el => el.formresponse_id === response.formresponse_id)
            if (index > -1) this.value.splice(index, 1)
            else this.value.push(response)
            
            this.$emit('input', this.value)
        },
        toPage(pageNo) {
            this.filters.page = pageNo
            this.fetchFormResponses()
        },
        refresh(filters) {
            this.filters = {
                ...this.filters,
                ...filters,
                page: 1,
            }
            this.fetchFormResponses()
        }
    }
}
</script>